import envConfig from '@hulu/env-config';

export enum ResultKeys {
  campaigns = 'campaigns',
  lineItems = 'lineItems',
  ads = 'ads',
  searchAssetsV5 = 'searchAssetsV5',
  searchAssets2 = 'searchAssets2',
  lineItemsV5 = 'lineItemsV5',
}

export enum QueryVariablesKeys {
  ids = 'ids',
  campaignIds = 'campaignIds',
  lineItemIds = 'lineItemIds',
  traffickerEmailList = 'traffickerEmailList',
  accountExecutiveList = 'accountExecutiveList',
  adProductList = 'adProductList',
  schedule = 'schedule',
  sort = 'sort',
  order = 'order',
  limit = 'limit',
  offset = 'offset',
  searchTerm = 'searchTerm',
  brandIdList = 'brandIdList',
  excludeBrandIdList = 'excludeBrandIdList',
  industryIdList = 'industryIdList',
  agencyIdList = 'agencyIdList',
  isAddedValue = 'isAddedValue',
  isCoppaOrCaru = 'isCoppaOrCaru',
  isMakegood = 'isMakegood',
  isRotation = 'isRotation',
  isSequence = 'isSequence',
  doNotTraffic = 'doNotTraffic',
  percentPacing = 'percentPacing',
  completionsRemaining = 'completionsRemaining',
  lineItemEndDate = 'lineItemEndDate',
  customPacingApplied = 'customPacingApplied',
  presetId = 'presetId',
  CPM = 'CPM',
  frequencyCap = 'frequencyCap',
}

export const BASIC_FILTERS_QUERY_VARIABLES = [
  'generalPacingStatusList',
  'lineItemTypeList',
  'reviewStatusList',
  'pacingRiskList',
  'adStatusList',
  'orderTypeList',
  'tierNameList',
  'priorityValueList',
  'billableThirdPartyList',
  'publisherList',
  'adTypeList',
  'creativeTypeList',
  'creativeReviewList',
  'countryList',
  'currencyList',
  'sspList',
  'costMethodList',
  'billableEventList',
  'distributionPartnerList',
];

export const DELIVERY_FORENSICS_LINK = envConfig.REACT_APP_DELIVERY_FORENSICS_LINK;

export const REACT_APP_MICROSTRATEGY_CAMPAIGN_REPORT_URL_PROMPTS_ANSWER_TAG =
  envConfig.REACT_APP_MICROSTRATEGY_CAMPAIGN_REPORT_URL_PROMPTS_ANSWER_TAG;
export const REACT_APP_MICROSTRATEGY_CAMPAIGN_REPORT_URL_TEMPLATE =
  envConfig.REACT_APP_MICROSTRATEGY_CAMPAIGN_REPORT_URL_TEMPLATE;
export const REACT_APP_MICROSTRATEGY_CAMPAIGN_REPORT_URL_MC_CAMPAIGN_UUID_TAG =
  envConfig.REACT_APP_MICROSTRATEGY_CAMPAIGN_REPORT_URL_MC_CAMPAIGN_UUID_TAG;
export const REACT_APP_MICROSTRATEGY_CAMPAIGN_REPORT_URL_PROMPTS_ANSWER_XML_TEMPLATE =
  envConfig.REACT_APP_MICROSTRATEGY_CAMPAIGN_REPORT_URL_PROMPTS_ANSWER_XML_TEMPLATE;

export const DEFAULT_COLUMN_MIN_WIDTH = 28;

export const DEFAULT_LIMIT = 20;

export const MAX_LIMIT = 1000;

// KATANA-1713: sent as the only idList entry so a tab with nothing selected returns no rows. An
// empty idList means "no id filter" server-side, and campaign-searcher rejects a blank id.
export const NO_MATCHING_IDS_ID = '__NO_MATCH__';

export const LOCAL_STORAGE_LOCATION_STATE = 'locationState';

export const UNFORMATTED_PUBLISHERS = {
  ESPN: 'ESPN',
};
